import { render, staticRenderFns } from "./Tos.vue?vue&type=template&id=54addf20&scoped=true&"
import script from "./Tos.vue?vue&type=script&lang=ts&"
export * from "./Tos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54addf20",
  null
  
)

export default component.exports